const countryCodeData = [
  {
    flag: require("../../assets/images/flags/qa.png"),
    name: "Qatar",
    alpha2Code: "QA",
    callingCode: "974",
  },
  {
    flag: require("../../assets/images/flags/af.png"),
    name: "Afghanistan",
    alpha2Code: "AF",
    callingCode: "93",
  },
  {
    flag: require("../../assets/images/flags/ax.png"),
    name: "Åland Islands",
    alpha2Code: "AX",
    callingCode: "358",
  },
  {
    flag: require("../../assets/images/flags/al.png"),
    name: "Albania",
    alpha2Code: "AL",
    callingCode: "355",
  },
  {
    flag: require("../../assets/images/flags/dz.png"),
    name: "Algeria",
    alpha2Code: "DZ",
    callingCode: "213",
  },
  {
    flag: require("../../assets/images/flags/as.png"),
    name: "American Samoa",
    alpha2Code: "AS",
    callingCode: "1684",
  },
  {
    flag: require("../../assets/images/flags/ad.png"),
    name: "Andorra",
    alpha2Code: "AD",
    callingCode: "376",
  },
  {
    flag: require("../../assets/images/flags/ao.png"),
    name: "Angola",
    alpha2Code: "AO",
    callingCode: "244",
  },
  {
    flag: require("../../assets/images/flags/ai.png"),
    name: "Anguilla",
    alpha2Code: "AI",
    callingCode: "1264",
  },
  {
    flag: require("../../assets/images/flags/aq.png"),
    name: "Antarctica",
    alpha2Code: "AQ",
    callingCode: "672",
  },
  {
    flag: require("../../assets/images/flags/ag.png"),
    name: "Antigua and Barbuda",
    alpha2Code: "AG",
    callingCode: "1268",
  },
  {
    flag: require("../../assets/images/flags/ar.png"),
    name: "Argentina",
    alpha2Code: "AR",
    callingCode: "54",
  },
  {
    flag: require("../../assets/images/flags/am.png"),
    name: "Armenia",
    alpha2Code: "AM",
    callingCode: "374",
  },
  {
    flag: require("../../assets/images/flags/aw.png"),
    name: "Aruba",
    alpha2Code: "AW",
    callingCode: "297",
  },
  {
    flag: require("../../assets/images/flags/au.png"),
    name: "Australia",
    alpha2Code: "AU",
    callingCode: "61",
  },
  {
    flag: require("../../assets/images/flags/at.png"),
    name: "Austria",
    alpha2Code: "AT",
    callingCode: "43",
  },
  {
    flag: require("../../assets/images/flags/az.png"),
    name: "Azerbaijan",
    alpha2Code: "AZ",
    callingCode: "994",
  },
  {
    flag: require("../../assets/images/flags/bs.png"),
    name: "Bahamas",
    alpha2Code: "BS",
    callingCode: "1242",
  },
  {
    flag: require("../../assets/images/flags/bh.png"),
    name: "Bahrain",
    alpha2Code: "BH",
    callingCode: "973",
  },
  {
    flag: require("../../assets/images/flags/bd.png"),
    name: "Bangladesh",
    alpha2Code: "BD",
    callingCode: "880",
  },
  {
    flag: require("../../assets/images/flags/bb.png"),
    name: "Barbados",
    alpha2Code: "BB",
    callingCode: "1246",
  },
  {
    flag: require("../../assets/images/flags/by.png"),
    name: "Belarus",
    alpha2Code: "BY",
    callingCode: "375",
  },
  {
    flag: require("../../assets/images/flags/be.png"),
    name: "Belgium",
    alpha2Code: "BE",
    callingCode: "32",
  },
  {
    flag: require("../../assets/images/flags/bz.png"),
    name: "Belize",
    alpha2Code: "BZ",
    callingCode: "501",
  },
  {
    flag: require("../../assets/images/flags/bj.png"),
    name: "Benin",
    alpha2Code: "BJ",
    callingCode: "229",
  },
  {
    flag: require("../../assets/images/flags/bm.png"),
    name: "Bermuda",
    alpha2Code: "BM",
    callingCode: "1441",
  },
  {
    flag: require("../../assets/images/flags/bt.png"),
    name: "Bhutan",
    alpha2Code: "BT",
    callingCode: "975",
  },
  {
    flag: require("../../assets/images/flags/bo.png"),
    name: "Bolivia (Plurinational State of)",
    alpha2Code: "BO",
    callingCode: "591",
  },
  {
    flag: require("../../assets/images/flags/bq.png"),
    name: "Bonaire, Sint Eustatius and Saba",
    alpha2Code: "BQ",
    callingCode: "5997",
  },
  {
    flag: require("../../assets/images/flags/ba.png"),
    name: "Bosnia and Herzegovina",
    alpha2Code: "BA",
    callingCode: "387",
  },
  {
    flag: require("../../assets/images/flags/bw.png"),
    name: "Botswana",
    alpha2Code: "BW",
    callingCode: "267",
  },
  {
    flag: require("../../assets/images/flags/br.png"),
    name: "Brazil",
    alpha2Code: "BR",
    callingCode: "55",
  },
  {
    flag: require("../../assets/images/flags/io.png"),
    name: "British Indian Ocean Territory",
    alpha2Code: "IO",
    callingCode: "246",
  },
  {
    flag: require("../../assets/images/flags/vg.png"),
    name: "Virgin Islands (British)",
    alpha2Code: "VG",
    callingCode: "1284",
  },
  {
    flag: require("../../assets/images/flags/vi.png"),
    name: "Virgin Islands (U.S.)",
    alpha2Code: "VI",
    callingCode: "1 340",
  },
  {
    flag: require("../../assets/images/flags/bn.png"),
    name: "Brunei Darussalam",
    alpha2Code: "BN",
    callingCode: "673",
  },
  {
    flag: require("../../assets/images/flags/bg.png"),
    name: "Bulgaria",
    alpha2Code: "BG",
    callingCode: "359",
  },
  {
    flag: require("../../assets/images/flags/bf.png"),
    name: "Burkina Faso",
    alpha2Code: "BF",
    callingCode: "226",
  },
  {
    flag: require("../../assets/images/flags/bi.png"),
    name: "Burundi",
    alpha2Code: "BI",
    callingCode: "257",
  },
  {
    flag: require("../../assets/images/flags/kh.png"),
    name: "Cambodia",
    alpha2Code: "KH",
    callingCode: "855",
  },
  {
    flag: require("../../assets/images/flags/cm.png"),
    name: "Cameroon",
    alpha2Code: "CM",
    callingCode: "237",
  },
  {
    flag: require("../../assets/images/flags/ca.png"),
    name: "Canada",
    alpha2Code: "CA",
    callingCode: "1",
  },
  {
    flag: require("../../assets/images/flags/cv.png"),
    name: "Cabo Verde",
    alpha2Code: "CV",
    callingCode: "238",
  },
  {
    flag: require("../../assets/images/flags/ky.png"),
    name: "Cayman Islands",
    alpha2Code: "KY",
    callingCode: "1345",
  },
  {
    flag: require("../../assets/images/flags/cf.png"),
    name: "Central African Republic",
    alpha2Code: "CF",
    callingCode: "236",
  },
  {
    flag: require("../../assets/images/flags/td.png"),
    name: "Chad",
    alpha2Code: "TD",
    callingCode: "235",
  },
  {
    flag: require("../../assets/images/flags/cl.png"),
    name: "Chile",
    alpha2Code: "CL",
    callingCode: "56",
  },
  {
    flag: require("../../assets/images/flags/cn.png"),
    name: "China",
    alpha2Code: "CN",
    callingCode: "86",
  },
  {
    flag: require("../../assets/images/flags/cx.png"),
    name: "Christmas Island",
    alpha2Code: "CX",
    callingCode: "61",
  },
  {
    flag: require("../../assets/images/flags/cc.png"),
    name: "Cocos (Keeling) Islands",
    alpha2Code: "CC",
    callingCode: "61",
  },
  {
    flag: require("../../assets/images/flags/co.png"),
    name: "Colombia",
    alpha2Code: "CO",
    callingCode: "57",
  },
  {
    flag: require("../../assets/images/flags/km.png"),
    name: "Comoros",
    alpha2Code: "KM",
    callingCode: "269",
  },
  {
    flag: require("../../assets/images/flags/cg.png"),
    name: "Congo",
    alpha2Code: "CG",
    callingCode: "242",
  },
  {
    flag: require("../../assets/images/flags/cd.png"),
    name: "Congo (Democratic Republic of the)",
    alpha2Code: "CD",
    callingCode: "243",
  },
  {
    flag: require("../../assets/images/flags/ck.png"),
    name: "Cook Islands",
    alpha2Code: "CK",
    callingCode: "682",
  },
  {
    flag: require("../../assets/images/flags/cr.png"),
    name: "Costa Rica",
    alpha2Code: "CR",
    callingCode: "506",
  },
  {
    flag: require("../../assets/images/flags/hr.png"),
    name: "Croatia",
    alpha2Code: "HR",
    callingCode: "385",
  },
  {
    flag: require("../../assets/images/flags/cu.png"),
    name: "Cuba",
    alpha2Code: "CU",
    callingCode: "53",
  },
  {
    flag: require("../../assets/images/flags/cw.png"),
    name: "Curaçao",
    alpha2Code: "CW",
    callingCode: "599",
  },
  {
    flag: require("../../assets/images/flags/cy.png"),
    name: "Cyprus",
    alpha2Code: "CY",
    callingCode: "357",
  },
  {
    flag: require("../../assets/images/flags/cz.png"),
    name: "Czech Republic",
    alpha2Code: "CZ",
    callingCode: "420",
  },
  {
    flag: require("../../assets/images/flags/dk.png"),
    name: "Denmark",
    alpha2Code: "DK",
    callingCode: "45",
  },
  {
    flag: require("../../assets/images/flags/dj.png"),
    name: "Djibouti",
    alpha2Code: "DJ",
    callingCode: "253",
  },
  {
    flag: require("../../assets/images/flags/dm.png"),
    name: "Dominica",
    alpha2Code: "DM",
    callingCode: "1767",
  },
  {
    flag: require("../../assets/images/flags/do.png"),
    name: "Dominican Republic",
    alpha2Code: "DO",
    callingCode: "1809",
  },
  {
    flag: require("../../assets/images/flags/ec.png"),
    name: "Ecuador",
    alpha2Code: "EC",
    callingCode: "593",
  },
  {
    flag: require("../../assets/images/flags/eg.png"),
    name: "Egypt",
    alpha2Code: "EG",
    callingCode: "20",
  },
  {
    flag: require("../../assets/images/flags/sv.png"),
    name: "El Salvador",
    alpha2Code: "SV",
    callingCode: "503",
  },
  {
    flag: require("../../assets/images/flags/gq.png"),
    name: "Equatorial Guinea",
    alpha2Code: "GQ",
    callingCode: "240",
  },
  {
    flag: require("../../assets/images/flags/er.png"),
    name: "Eritrea",
    alpha2Code: "ER",
    callingCode: "291",
  },
  {
    flag: require("../../assets/images/flags/ee.png"),
    name: "Estonia",
    alpha2Code: "EE",
    callingCode: "372",
  },
  {
    flag: require("../../assets/images/flags/et.png"),
    name: "Ethiopia",
    alpha2Code: "ET",
    callingCode: "251",
  },
  {
    flag: require("../../assets/images/flags/fk.png"),
    name: "Falkland Islands (Malvinas)",
    alpha2Code: "FK",
    callingCode: "500",
  },
  {
    flag: require("../../assets/images/flags/fo.png"),
    name: "Faroe Islands",
    alpha2Code: "FO",
    callingCode: "298",
  },
  {
    flag: require("../../assets/images/flags/fj.png"),
    name: "Fiji",
    alpha2Code: "FJ",
    callingCode: "679",
  },
  {
    flag: require("../../assets/images/flags/fi.png"),
    name: "Finland",
    alpha2Code: "FI",
    callingCode: "358",
  },
  {
    flag: require("../../assets/images/flags/fr.png"),
    name: "France",
    alpha2Code: "FR",
    callingCode: "33",
  },
  {
    flag: require("../../assets/images/flags/gf.png"),
    name: "French Guiana",
    alpha2Code: "GF",
    callingCode: "594",
  },
  {
    flag: require("../../assets/images/flags/pf.png"),
    name: "French Polynesia",
    alpha2Code: "PF",
    callingCode: "689",
  },
  {
    flag: require("../../assets/images/flags/ga.png"),
    name: "Gabon",
    alpha2Code: "GA",
    callingCode: "241",
  },
  {
    flag: require("../../assets/images/flags/gm.png"),
    name: "Gambia",
    alpha2Code: "GM",
    callingCode: "220",
  },
  {
    flag: require("../../assets/images/flags/ge.png"),
    name: "Georgia",
    alpha2Code: "GE",
    callingCode: "995",
  },
  {
    flag: require("../../assets/images/flags/de.png"),
    name: "Germany",
    alpha2Code: "DE",
    callingCode: "49",
  },
  {
    flag: require("../../assets/images/flags/gh.png"),
    name: "Ghana",
    alpha2Code: "GH",
    callingCode: "233",
  },
  {
    flag: require("../../assets/images/flags/gi.png"),
    name: "Gibraltar",
    alpha2Code: "GI",
    callingCode: "350",
  },
  {
    flag: require("../../assets/images/flags/gr.png"),
    name: "Greece",
    alpha2Code: "GR",
    callingCode: "30",
  },
  {
    flag: require("../../assets/images/flags/gl.png"),
    name: "Greenland",
    alpha2Code: "GL",
    callingCode: "299",
  },
  {
    flag: require("../../assets/images/flags/gd.png"),
    name: "Grenada",
    alpha2Code: "GD",
    callingCode: "1473",
  },
  {
    flag: require("../../assets/images/flags/gp.png"),
    name: "Guadeloupe",
    alpha2Code: "GP",
    callingCode: "590",
  },
  {
    flag: require("../../assets/images/flags/gu.png"),
    name: "Guam",
    alpha2Code: "GU",
    callingCode: "1671",
  },
  {
    flag: require("../../assets/images/flags/gt.png"),
    name: "Guatemala",
    alpha2Code: "GT",
    callingCode: "502",
  },
  {
    flag: require("../../assets/images/flags/gg.png"),
    name: "Guernsey",
    alpha2Code: "GG",
    callingCode: "44",
  },
  {
    flag: require("../../assets/images/flags/gn.png"),
    name: "Guinea",
    alpha2Code: "GN",
    callingCode: "224",
  },
  {
    flag: require("../../assets/images/flags/gw.png"),
    name: "Guinea-Bissau",
    alpha2Code: "GW",
    callingCode: "245",
  },
  {
    flag: require("../../assets/images/flags/gy.png"),
    name: "Guyana",
    alpha2Code: "GY",
    callingCode: "592",
  },
  {
    flag: require("../../assets/images/flags/ht.png"),
    name: "Haiti",
    alpha2Code: "HT",
    callingCode: "509",
  },
  {
    flag: require("../../assets/images/flags/va.png"),
    name: "Holy See",
    alpha2Code: "VA",
    callingCode: "379",
  },
  {
    flag: require("../../assets/images/flags/hn.png"),
    name: "Honduras",
    alpha2Code: "HN",
    callingCode: "504",
  },
  {
    flag: require("../../assets/images/flags/hk.png"),
    name: "Hong Kong",
    alpha2Code: "HK",
    callingCode: "852",
  },
  {
    flag: require("../../assets/images/flags/hu.png"),
    name: "Hungary",
    alpha2Code: "HU",
    callingCode: "36",
  },
  {
    flag: require("../../assets/images/flags/is.png"),
    name: "Iceland",
    alpha2Code: "IS",
    callingCode: "354",
  },
  {
    flag: require("../../assets/images/flags/in.png"),
    name: "India",
    alpha2Code: "IN",
    callingCode: "91",
  },
  {
    flag: require("../../assets/images/flags/id.png"),
    name: "Indonesia",
    alpha2Code: "ID",
    callingCode: "62",
  },
  {
    flag: require("../../assets/images/flags/ci.png"),
    name: "Côte d'Ivoire",
    alpha2Code: "CI",
    callingCode: "225",
  },
  {
    flag: require("../../assets/images/flags/ir.png"),
    name: "Iran (Islamic Republic of)",
    alpha2Code: "IR",
    callingCode: "98",
  },
  {
    flag: require("../../assets/images/flags/iq.png"),
    name: "Iraq",
    alpha2Code: "IQ",
    callingCode: "964",
  },
  {
    flag: require("../../assets/images/flags/ie.png"),
    name: "Ireland",
    alpha2Code: "IE",
    callingCode: "353",
  },
  {
    flag: require("../../assets/images/flags/im.png"),
    name: "Isle of Man",
    alpha2Code: "IM",
    callingCode: "44",
  },
  {
    flag: require("../../assets/images/flags/il.png"),
    name: "Israel",
    alpha2Code: "IL",
    callingCode: "972",
  },
  {
    flag: require("../../assets/images/flags/it.png"),
    name: "Italy",
    alpha2Code: "IT",
    callingCode: "39",
  },
  {
    flag: require("../../assets/images/flags/jm.png"),
    name: "Jamaica",
    alpha2Code: "JM",
    callingCode: "1876",
  },
  {
    flag: require("../../assets/images/flags/jp.png"),
    name: "Japan",
    alpha2Code: "JP",
    callingCode: "81",
  },
  {
    flag: require("../../assets/images/flags/je.png"),
    name: "Jersey",
    alpha2Code: "JE",
    callingCode: "44",
  },
  {
    flag: require("../../assets/images/flags/jo.png"),
    name: "Jordan",
    alpha2Code: "JO",
    callingCode: "962",
  },
  {
    flag: require("../../assets/images/flags/kz.png"),
    name: "Kazakhstan",
    alpha2Code: "KZ",
    callingCode: "76",
  },
  {
    flag: require("../../assets/images/flags/ke.png"),
    name: "Kenya",
    alpha2Code: "KE",
    callingCode: "254",
  },
  {
    flag: require("../../assets/images/flags/ki.png"),
    name: "Kiribati",
    alpha2Code: "KI",
    callingCode: "686",
  },
  {
    flag: require("../../assets/images/flags/kw.png"),
    name: "Kuwait",
    alpha2Code: "KW",
    callingCode: "965",
  },
  {
    flag: require("../../assets/images/flags/kg.png"),
    name: "Kyrgyzstan",
    alpha2Code: "KG",
    callingCode: "996",
  },
  {
    flag: require("../../assets/images/flags/la.png"),
    name: "Lao People's Democratic Republic",
    alpha2Code: "LA",
    callingCode: "856",
  },
  {
    flag: require("../../assets/images/flags/lv.png"),
    name: "Latvia",
    alpha2Code: "LV",
    callingCode: "371",
  },
  {
    flag: require("../../assets/images/flags/lb.png"),
    name: "Lebanon",
    alpha2Code: "LB",
    callingCode: "961",
  },
  {
    flag: require("../../assets/images/flags/ls.png"),
    name: "Lesotho",
    alpha2Code: "LS",
    callingCode: "266",
  },
  {
    flag: require("../../assets/images/flags/lr.png"),
    name: "Liberia",
    alpha2Code: "LR",
    callingCode: "231",
  },
  {
    flag: require("../../assets/images/flags/ly.png"),
    name: "Libya",
    alpha2Code: "LY",
    callingCode: "218",
  },
  {
    flag: require("../../assets/images/flags/li.png"),
    name: "Liechtenstein",
    alpha2Code: "LI",
    callingCode: "423",
  },
  {
    flag: require("../../assets/images/flags/lt.png"),
    name: "Lithuania",
    alpha2Code: "LT",
    callingCode: "370",
  },
  {
    flag: require("../../assets/images/flags/lu.png"),
    name: "Luxembourg",
    alpha2Code: "LU",
    callingCode: "352",
  },
  {
    flag: require("../../assets/images/flags/mo.png"),
    name: "Macao",
    alpha2Code: "MO",
    callingCode: "853",
  },
  {
    flag: require("../../assets/images/flags/mk.png"),
    name: "Macedonia (the former Yugoslav Republic of)",
    alpha2Code: "MK",
    callingCode: "389",
  },
  {
    flag: require("../../assets/images/flags/mg.png"),
    name: "Madagascar",
    alpha2Code: "MG",
    callingCode: "261",
  },
  {
    flag: require("../../assets/images/flags/mw.png"),
    name: "Malawi",
    alpha2Code: "MW",
    callingCode: "265",
  },
  {
    flag: require("../../assets/images/flags/my.png"),
    name: "Malaysia",
    alpha2Code: "MY",
    callingCode: "60",
  },
  {
    flag: require("../../assets/images/flags/mv.png"),
    name: "Maldives",
    alpha2Code: "MV",
    callingCode: "960",
  },
  {
    flag: require("../../assets/images/flags/ml.png"),
    name: "Mali",
    alpha2Code: "ML",
    callingCode: "223",
  },
  {
    flag: require("../../assets/images/flags/mt.png"),
    name: "Malta",
    alpha2Code: "MT",
    callingCode: "356",
  },
  {
    flag: require("../../assets/images/flags/mh.png"),
    name: "Marshall Islands",
    alpha2Code: "MH",
    callingCode: "692",
  },
  {
    flag: require("../../assets/images/flags/mq.png"),
    name: "Martinique",
    alpha2Code: "MQ",
    callingCode: "596",
  },
  {
    flag: require("../../assets/images/flags/mr.png"),
    name: "Mauritania",
    alpha2Code: "MR",
    callingCode: "222",
  },
  {
    flag: require("../../assets/images/flags/mu.png"),
    name: "Mauritius",
    alpha2Code: "MU",
    callingCode: "230",
  },
  {
    flag: require("../../assets/images/flags/yt.png"),
    name: "Mayotte",
    alpha2Code: "YT",
    callingCode: "262",
  },
  {
    flag: require("../../assets/images/flags/mx.png"),
    name: "Mexico",
    alpha2Code: "MX",
    callingCode: "52",
  },
  {
    flag: require("../../assets/images/flags/fm.png"),
    name: "Micronesia (Federated States of)",
    alpha2Code: "FM",
    callingCode: "691",
  },
  {
    flag: require("../../assets/images/flags/md.png"),
    name: "Moldova (Republic of)",
    alpha2Code: "MD",
    callingCode: "373",
  },
  {
    flag: require("../../assets/images/flags/mc.png"),
    name: "Monaco",
    alpha2Code: "MC",
    callingCode: "377",
  },
  {
    flag: require("../../assets/images/flags/mn.png"),
    name: "Mongolia",
    alpha2Code: "MN",
    callingCode: "976",
  },
  {
    flag: require("../../assets/images/flags/me.png"),
    name: "Montenegro",
    alpha2Code: "ME",
    callingCode: "382",
  },
  {
    flag: require("../../assets/images/flags/ms.png"),
    name: "Montserrat",
    alpha2Code: "MS",
    callingCode: "1664",
  },
  {
    flag: require("../../assets/images/flags/ma.png"),
    name: "Morocco",
    alpha2Code: "MA",
    callingCode: "212",
  },
  {
    flag: require("../../assets/images/flags/mz.png"),
    name: "Mozambique",
    alpha2Code: "MZ",
    callingCode: "258",
  },
  {
    flag: require("../../assets/images/flags/mm.png"),
    name: "Myanmar",
    alpha2Code: "MM",
    callingCode: "95",
  },
  {
    flag: require("../../assets/images/flags/na.png"),
    name: "Namibia",
    alpha2Code: "NA",
    callingCode: "264",
  },
  {
    flag: require("../../assets/images/flags/nr.png"),
    name: "Nauru",
    alpha2Code: "NR",
    callingCode: "674",
  },
  {
    flag: require("../../assets/images/flags/np.png"),
    name: "Nepal",
    alpha2Code: "NP",
    callingCode: "977",
  },
  {
    flag: require("../../assets/images/flags/nl.png"),
    name: "Netherlands",
    alpha2Code: "NL",
    callingCode: "31",
  },
  {
    flag: require("../../assets/images/flags/nc.png"),
    name: "New Caledonia",
    alpha2Code: "NC",
    callingCode: "687",
  },
  {
    flag: require("../../assets/images/flags/nz.png"),
    name: "New Zealand",
    alpha2Code: "NZ",
    callingCode: "64",
  },
  {
    flag: require("../../assets/images/flags/ni.png"),
    name: "Nicaragua",
    alpha2Code: "NI",
    callingCode: "505",
  },
  {
    flag: require("../../assets/images/flags/ne.png"),
    name: "Niger",
    alpha2Code: "NE",
    callingCode: "227",
  },
  {
    flag: require("../../assets/images/flags/ng.png"),
    name: "Nigeria",
    alpha2Code: "NG",
    callingCode: "234",
  },
  {
    flag: require("../../assets/images/flags/nu.png"),
    name: "Niue",
    alpha2Code: "NU",
    callingCode: "683",
  },
  {
    flag: require("../../assets/images/flags/nf.png"),
    name: "Norfolk Island",
    alpha2Code: "NF",
    callingCode: "672",
  },
  {
    flag: require("../../assets/images/flags/kp.png"),
    name: "Korea (Democratic People's Republic of)",
    alpha2Code: "KP",
    callingCode: "850",
  },
  {
    flag: require("../../assets/images/flags/mp.png"),
    name: "Northern Mariana Islands",
    alpha2Code: "MP",
    callingCode: "1670",
  },
  {
    flag: require("../../assets/images/flags/no.png"),
    name: "Norway",
    alpha2Code: "NO",
    callingCode: "47",
  },
  {
    flag: require("../../assets/images/flags/om.png"),
    name: "Oman",
    alpha2Code: "OM",
    callingCode: "968",
  },
  {
    flag: require("../../assets/images/flags/pk.png"),
    name: "Pakistan",
    alpha2Code: "PK",
    callingCode: "92",
  },
  {
    flag: require("../../assets/images/flags/pw.png"),
    name: "Palau",
    alpha2Code: "PW",
    callingCode: "680",
  },
  {
    flag: require("../../assets/images/flags/ps.png"),
    name: "Palestine, State of",
    alpha2Code: "PS",
    callingCode: "970",
  },
  {
    flag: require("../../assets/images/flags/pa.png"),
    name: "Panama",
    alpha2Code: "PA",
    callingCode: "507",
  },
  {
    flag: require("../../assets/images/flags/pg.png"),
    name: "Papua New Guinea",
    alpha2Code: "PG",
    callingCode: "675",
  },
  {
    flag: require("../../assets/images/flags/py.png"),
    name: "Paraguay",
    alpha2Code: "PY",
    callingCode: "595",
  },
  {
    flag: require("../../assets/images/flags/pe.png"),
    name: "Peru",
    alpha2Code: "PE",
    callingCode: "51",
  },
  {
    flag: require("../../assets/images/flags/ph.png"),
    name: "Philippines",
    alpha2Code: "PH",
    callingCode: "63",
  },
  {
    flag: require("../../assets/images/flags/pn.png"),
    name: "Pitcairn",
    alpha2Code: "PN",
    callingCode: "64",
  },
  {
    flag: require("../../assets/images/flags/pl.png"),
    name: "Poland",
    alpha2Code: "PL",
    callingCode: "48",
  },
  {
    flag: require("../../assets/images/flags/pt.png"),
    name: "Portugal",
    alpha2Code: "PT",
    callingCode: "351",
  },
  {
    flag: require("../../assets/images/flags/pr.png"),
    name: "Puerto Rico",
    alpha2Code: "PR",
    callingCode: "1787",
  },
  {
    flag: require("../../assets/images/flags/xk.png"),
    name: "Republic of Kosovo",
    alpha2Code: "XK",
    callingCode: "383",
  },
  {
    flag: require("../../assets/images/flags/re.png"),
    name: "Réunion",
    alpha2Code: "RE",
    callingCode: "262",
  },
  {
    flag: require("../../assets/images/flags/ro.png"),
    name: "Romania",
    alpha2Code: "RO",
    callingCode: "40",
  },
  {
    flag: require("../../assets/images/flags/ru.png"),
    name: "Russian Federation",
    alpha2Code: "RU",
    callingCode: "7",
  },
  {
    flag: require("../../assets/images/flags/rw.png"),
    name: "Rwanda",
    alpha2Code: "RW",
    callingCode: "250",
  },
  {
    flag: require("../../assets/images/flags/bl.png"),
    name: "Saint Barthélemy",
    alpha2Code: "BL",
    callingCode: "590",
  },
  {
    flag: require("../../assets/images/flags/sh.png"),
    name: "Saint Helena, Ascension and Tristan da Cunha",
    alpha2Code: "SH",
    callingCode: "290",
  },
  {
    flag: require("../../assets/images/flags/kn.png"),
    name: "Saint Kitts and Nevis",
    alpha2Code: "KN",
    callingCode: "1869",
  },
  {
    flag: require("../../assets/images/flags/lc.png"),
    name: "Saint Lucia",
    alpha2Code: "LC",
    callingCode: "1758",
  },
  {
    flag: require("../../assets/images/flags/mf.png"),
    name: "Saint Martin (French part)",
    alpha2Code: "MF",
    callingCode: "590",
  },
  {
    flag: require("../../assets/images/flags/pm.png"),
    name: "Saint Pierre and Miquelon",
    alpha2Code: "PM",
    callingCode: "508",
  },
  {
    flag: require("../../assets/images/flags/vc.png"),
    name: "Saint Vincent and the Grenadines",
    alpha2Code: "VC",
    callingCode: "1784",
  },
  {
    flag: require("../../assets/images/flags/ws.png"),
    name: "Samoa",
    alpha2Code: "WS",
    callingCode: "685",
  },
  {
    flag: require("../../assets/images/flags/sm.png"),
    name: "San Marino",
    alpha2Code: "SM",
    callingCode: "378",
  },
  {
    flag: require("../../assets/images/flags/st.png"),
    name: "Sao Tome and Principe",
    alpha2Code: "ST",
    callingCode: "239",
  },
  {
    flag: require("../../assets/images/flags/sa.png"),
    name: "Saudi Arabia",
    alpha2Code: "SA",
    callingCode: "966",
  },
  {
    flag: require("../../assets/images/flags/sn.png"),
    name: "Senegal",
    alpha2Code: "SN",
    callingCode: "221",
  },
  {
    flag: require("../../assets/images/flags/rs.png"),
    name: "Serbia",
    alpha2Code: "RS",
    callingCode: "381",
  },
  {
    flag: require("../../assets/images/flags/sc.png"),
    name: "Seychelles",
    alpha2Code: "SC",
    callingCode: "248",
  },
  {
    flag: require("../../assets/images/flags/sl.png"),
    name: "Sierra Leone",
    alpha2Code: "SL",
    callingCode: "232",
  },
  {
    flag: require("../../assets/images/flags/sg.png"),
    name: "Singapore",
    alpha2Code: "SG",
    callingCode: "65",
  },
  {
    flag: require("../../assets/images/flags/sx.png"),
    name: "Sint Maarten (Dutch part)",
    alpha2Code: "SX",
    callingCode: "1721",
  },
  {
    flag: require("../../assets/images/flags/sk.png"),
    name: "Slovakia",
    alpha2Code: "SK",
    callingCode: "421",
  },
  {
    flag: require("../../assets/images/flags/si.png"),
    name: "Slovenia",
    alpha2Code: "SI",
    callingCode: "386",
  },
  {
    flag: require("../../assets/images/flags/sb.png"),
    name: "Solomon Islands",
    alpha2Code: "SB",
    callingCode: "677",
  },
  {
    flag: require("../../assets/images/flags/so.png"),
    name: "Somalia",
    alpha2Code: "SO",
    callingCode: "252",
  },
  {
    flag: require("../../assets/images/flags/za.png"),
    name: "South Africa",
    alpha2Code: "ZA",
    callingCode: "27",
  },
  {
    flag: require("../../assets/images/flags/gs.png"),
    name: "South Georgia and the South Sandwich Islands",
    alpha2Code: "GS",
    callingCode: "500",
  },
  {
    flag: require("../../assets/images/flags/kr.png"),
    name: "Korea (Republic of)",
    alpha2Code: "KR",
    callingCode: "82",
  },
  {
    flag: require("../../assets/images/flags/ss.png"),
    name: "South Sudan",
    alpha2Code: "SS",
    callingCode: "211",
  },
  {
    flag: require("../../assets/images/flags/es.png"),
    name: "Spain",
    alpha2Code: "ES",
    callingCode: "34",
  },
  {
    flag: require("../../assets/images/flags/lk.png"),
    name: "Sri Lanka",
    alpha2Code: "LK",
    callingCode: "94",
  },
  {
    flag: require("../../assets/images/flags/sd.png"),
    name: "Sudan",
    alpha2Code: "SD",
    callingCode: "249",
  },
  {
    flag: require("../../assets/images/flags/sr.png"),
    name: "Suriname",
    alpha2Code: "SR",
    callingCode: "597",
  },
  {
    flag: require("../../assets/images/flags/sj.png"),
    name: "Svalbard and Jan Mayen",
    alpha2Code: "SJ",
    callingCode: "4779",
  },
  {
    flag: require("../../assets/images/flags/sz.png"),
    name: "Swaziland",
    alpha2Code: "SZ",
    callingCode: "268",
  },
  {
    flag: require("../../assets/images/flags/se.png"),
    name: "Sweden",
    alpha2Code: "SE",
    callingCode: "46",
  },
  {
    flag: require("../../assets/images/flags/ch.png"),
    name: "Switzerland",
    alpha2Code: "CH",
    callingCode: "41",
  },
  {
    flag: require("../../assets/images/flags/sy.png"),
    name: "Syrian Arab Republic",
    alpha2Code: "SY",
    callingCode: "963",
  },
  {
    flag: require("../../assets/images/flags/tw.png"),
    name: "Taiwan",
    alpha2Code: "TW",
    callingCode: "886",
  },
  {
    flag: require("../../assets/images/flags/tj.png"),
    name: "Tajikistan",
    alpha2Code: "TJ",
    callingCode: "992",
  },
  {
    flag: require("../../assets/images/flags/tz.png"),
    name: "Tanzania, United Republic of",
    alpha2Code: "TZ",
    callingCode: "255",
  },
  {
    flag: require("../../assets/images/flags/th.png"),
    name: "Thailand",
    alpha2Code: "TH",
    callingCode: "66",
  },
  {
    flag: require("../../assets/images/flags/tl.png"),
    name: "Timor-Leste",
    alpha2Code: "TL",
    callingCode: "670",
  },
  {
    flag: require("../../assets/images/flags/tg.png"),
    name: "Togo",
    alpha2Code: "TG",
    callingCode: "228",
  },
  {
    flag: require("../../assets/images/flags/tk.png"),
    name: "Tokelau",
    alpha2Code: "TK",
    callingCode: "690",
  },
  {
    flag: require("../../assets/images/flags/to.png"),
    name: "Tonga",
    alpha2Code: "TO",
    callingCode: "676",
  },
  {
    flag: require("../../assets/images/flags/tt.png"),
    name: "Trinidad and Tobago",
    alpha2Code: "TT",
    callingCode: "1868",
  },
  {
    flag: require("../../assets/images/flags/tn.png"),
    name: "Tunisia",
    alpha2Code: "TN",
    callingCode: "216",
  },
  {
    flag: require("../../assets/images/flags/tr.png"),
    name: "Turkey",
    alpha2Code: "TR",
    callingCode: "90",
  },
  {
    flag: require("../../assets/images/flags/tm.png"),
    name: "Turkmenistan",
    alpha2Code: "TM",
    callingCode: "993",
  },
  {
    flag: require("../../assets/images/flags/tc.png"),
    name: "Turks and Caicos Islands",
    alpha2Code: "TC",
    callingCode: "1649",
  },
  {
    flag: require("../../assets/images/flags/tv.png"),
    name: "Tuvalu",
    alpha2Code: "TV",
    callingCode: "688",
  },
  {
    flag: require("../../assets/images/flags/ug.png"),
    name: "Uganda",
    alpha2Code: "UG",
    callingCode: "256",
  },
  {
    flag: require("../../assets/images/flags/ua.png"),
    name: "Ukraine",
    alpha2Code: "UA",
    callingCode: "380",
  },
  {
    flag: require("../../assets/images/flags/ae.png"),
    name: "United Arab Emirates",
    alpha2Code: "AE",
    callingCode: "971",
  },
  {
    flag: require("../../assets/images/flags/gb.png"),
    name: "United Kingdom of Great Britain and Northern Ireland",
    alpha2Code: "GB",
    callingCode: "44",
  },
  {
    flag: require("../../assets/images/flags/us.png"),
    name: "United States of America",
    alpha2Code: "US",
    callingCode: "1",
  },
  {
    flag: require("../../assets/images/flags/uy.png"),
    name: "Uruguay",
    alpha2Code: "UY",
    callingCode: "598",
  },
  {
    flag: require("../../assets/images/flags/uz.png"),
    name: "Uzbekistan",
    alpha2Code: "UZ",
    callingCode: "998",
  },
  {
    flag: require("../../assets/images/flags/vu.png"),
    name: "Vanuatu",
    alpha2Code: "VU",
    callingCode: "678",
  },
  {
    flag: require("../../assets/images/flags/ve.png"),
    name: "Venezuela (Bolivarian Republic of)",
    alpha2Code: "VE",
    callingCode: "58",
  },
  {
    flag: require("../../assets/images/flags/vn.png"),
    name: "Viet Nam",
    alpha2Code: "VN",
    callingCode: "84",
  },
  {
    flag: require("../../assets/images/flags/wf.png"),
    name: "Wallis and Futuna",
    alpha2Code: "WF",
    callingCode: "681",
  },
  {
    flag: require("../../assets/images/flags/eh.png"),
    name: "Western Sahara",
    alpha2Code: "EH",
    callingCode: "212",
  },
  {
    flag: require("../../assets/images/flags/ye.png"),
    name: "Yemen",
    alpha2Code: "YE",
    callingCode: "967",
  },
  {
    flag: require("../../assets/images/flags/zm.png"),
    name: "Zambia",
    alpha2Code: "ZM",
    callingCode: "260",
  },
  {
    flag: require("../../assets/images/flags/zw.png"),
    name: "Zimbabwe",
    alpha2Code: "ZW",
    callingCode: "263",
  },
];

export default countryCodeData;